import makeStyles from '@mui/styles/makeStyles';
import classNames from "classnames";
import {Info} from "lucide-react";
import React from "react";
import {useTranslation} from "react-i18next";
import {isOffIst} from "business/callSlots";
import {color, type} from "common/tokens";

const useStyles = makeStyles({
  note: {
    ...type.meta,
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    color: color.TEXT_MUTED,
    margin: 0,
  },
  icon: {
    flexShrink: 0,
  },
});

const IstNote = ({className}) => {
  const classes = useStyles();
  const {t} = useTranslation();
  if (!isOffIst()) {
    return null;
  }
  return (
    <p className={classNames(classes.note, className)}>
      <Info size={14} strokeWidth={2.25} className={classes.icon}/>
      {t('slotTimesInIst')}
    </p>
  );
};

export default IstNote;
